// src/types/enums.ts (Example)
export enum AppointmentStatus {
  PENDING = "pending",
  CONFIRMED = "confirmed",
  CANCELLED = "cancelled",
  DONE = "done",
}
